module.exports = {
	"id": "GT",
	"name": "Guatemala",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.021744,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.02718,
			"19": null,
			"20": null,
			"21": 0.010872,
			"22": 0.032616,
			"23": 0.005436,
			"24": null,
			"25": 0.010872,
			"26": 0.021744,
			"27": 0.005436,
			"28": 0.005436,
			"29": 0.010872,
			"30": 0.005436,
			"31": 0.02718,
			"32": 0.005436,
			"33": 0.010872,
			"34": 0.02718,
			"35": 0.021744,
			"36": 0.021744,
			"37": 0.02718,
			"38": 0.032616,
			"39": 0.043488,
			"40": 0.038052,
			"41": 0.02718,
			"42": 0.021744,
			"43": 0.08154,
			"44": 0.065232,
			"45": 0.043488,
			"46": 0.065232,
			"47": 0.08154,
			"48": 0.086976,
			"49": 2.402712,
			"50": 0.152208,
			"51": 0.342468,
			"52": 0.38052,
			"53": 25.184988,
			"54": 6.816744,
			"55": 0.048924,
			"56": 0.016308,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.038052,
			"4": 0.005436,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.010872,
			"13": 0.005436,
			"14": null,
			"15": null,
			"16": 0.010872,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.005436,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.005436,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.016308,
			"31": 0.005436,
			"32": 0.005436,
			"33": 0.010872,
			"34": 0.010872,
			"35": 0.016308,
			"36": 0.005436,
			"37": 0.021744,
			"38": 0.02718,
			"39": 0.02718,
			"40": 0.021744,
			"41": 0.016308,
			"42": 0.032616,
			"43": 0.130464,
			"44": 0.048924,
			"45": 0.08154,
			"46": 0.05436,
			"47": 0.32616,
			"48": 0.413136,
			"49": 3.973716,
			"50": 0.02718,
			"51": 0.016308,
			"52": null,
			"3.5": null,
			"3.6": 0.021744
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.021744,
			"30": 0.005436,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.010872,
			"35": 0.005436,
			"36": 0.02718,
			"37": 0.097848,
			"38": 0.010872,
			"39": 0.016308,
			"40": 0.35334,
			"41": 0.043488,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.005436
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.02718,
			"6": 0.010872,
			"7": 0.038052,
			"8": 0.222876,
			"9": 0.309852,
			"10": 1.000224,
			"3.1": null,
			"3.2": null,
			"5.1": 0.059796,
			"6.1": 0.038052,
			"7.1": 0.02718,
			"9.1": 0.886068
		},
		"ios_saf": {
			"8": 0,
			"10": 2.26195412157,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0609570462115,
			"8.1-8.4": 0.11261555995,
			"9.0-9.2": 0.0537248542881,
			"9.3": 0.819648417985
		},
		"android": {
			"3": 0,
			"4": 0.103108661499,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0128885826873,
			"4.1": 0.371927671835,
			"4.2-4.3": 0.929819179587,
			"4.4": 2.13213982171,
			"4.4.3-4.4.4": 2.15055208269
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.169658481356,
			"9": 0.109457084746,
			"10": 0.153239918644,
			"11": 1.18213651525,
			"5.5": null
		},
		"op_mob": {
			"0": 0.365104794903,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0101417998584
		},
		"edge": {
			"12": 0.097848,
			"13": 0.2718,
			"14": 0.418572
		},
		"ie_mob": {
			"10": 0.122392338028,
			"11": 0.498311661972
		},
		"bb": {
			"7": 0.062755,
			"10": null
		},
		"samsung": {
			"0": 3.769864
		},
		"and_uc": {
			"0": 2.30482
		},
		"op_mini": {
			"0": 4.91899340524
		},
		"and_chr": {
			"0": 30.792196
		},
		"and_ff": {
			"0": 0.009128
		}
	},
	"total": 99.107319
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GT.json
 ** module id = 538
 ** module chunks = 0
 **/